export default __webpack_public_path__ + "static/media/wallart3.faa3c8eb.jpg";